// The vault header's Clone button: copies the exact CLI command that clones
// this vault (`cairn vault clone <id>` — the id, because it's unambiguous
// where a name may not be) so the user can paste it straight into a terminal
// on the machine they're setting up. Editing/sync happen in Obsidian via the
// CLI, so "get this vault onto a machine" is the one action the web app can
// meaningfully offer here.

import { IconCheck, IconTerminal2 } from "@tabler/icons-react";
import { toast } from "sonner";
import { useCopy } from "@/lib/use-copy";
import { Button } from "@/components/ui/button";

export function CloneVaultButton({ vaultId }: { vaultId: string }) {
  const { copied, copy } = useCopy();
  const command = `cairn vault clone ${vaultId}`;

  async function onClick() {
    if (!(await copy(command))) return;
    toast.success("Clone command copied", {
      description: "Paste it in a terminal on the machine you're setting up.",
    });
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label={`Copy clone command: ${command}`}
      onClick={() => void onClick()}
    >
      {copied ? (
        <IconCheck data-icon="inline-start" className="text-emerald-500" />
      ) : (
        <IconTerminal2 data-icon="inline-start" />
      )}
      Clone
    </Button>
  );
}
